import {IdValue} from '../model/id-value';

export class ArrayUtils {

  public static addElementIfNotExists<T>(array: Array<T>, element: T): void {
    let index = array.indexOf(element);
    if (index === -1) {
      array.push(element);
    }
  }

  public static removeElement<T>(array: Array<T>, element: T): void {
    let index = array.indexOf(element);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  public static removeIdValue<T>(array: Array<IdValue<T>>, id: number): void {
    let index = array.findIndex(it => it.id === id)
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

}

export const distinctByKey = <T, K extends keyof T>(array: T[], key: K) => {
  const counts = new Map<T[K], boolean>();
  const filtered: T[] = [];
  array.forEach(it => {
    let item = counts.get(it[key]);
    if (!item) {
      counts.set(it[key], true)
      filtered.push(it);
    }
  });
  return filtered;
}
